import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_GET_CARPARK_INVOICES_LIST,
  CPM_DOWNLOAD_CARPARK_INVOICE,
  CPM_DOWNLOAD_CARPARK_INVOICES,
  CPM_UPDATE_CARPARK_INVOICE,
  CPM_RESET_CARPARK_INVOICE_DOWNLOAD_REQUEST,
  REINIT_STATE,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/invoice';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkInvoice;
const cpmCarparkInvoice = (state = initialSettings, action) => {
  let mutationResult;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (
        action.target === 'fullCarpark'
        || action.target === 'currentCarpark'
        || action.target === 'carparkInvoiceDownload'
      ) {
        return {
          ...state,
          list: { ...initialSettings.list },
          downloadOne: { ...initialSettings.downloadOne },
          downloadMultiple: { ...initialSettings.downloadMultiple },
          update: { ...initialSettings.update },
        };
      }
      if (action.target === 'updateCarparkInvoice') {
        return {
          ...state,
          update: { ...initialSettings.update },
        };
      }
      return state;
    // CPM_GET_CARPARK_INVOICES_LIST
    case CPM_GET_CARPARK_INVOICES_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
          },
        },
      };
    case `${CPM_GET_CARPARK_INVOICES_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_CARPARK_INVOICES_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listCarparkInvoices.entries),
            pageNumber: _parseInt(action.data.listCarparkInvoices.pageNumber),
            pageSize: _parseInt(action.data.listCarparkInvoices.pageSize),
            totalEntries: _parseInt(
              action.data.listCarparkInvoices.totalEntries,
            ),
            totalPages: _parseInt(action.data.listCarparkInvoices.totalPages),
          },
        },
      };
    // CPM_DOWNLOAD_CARPARK_INVOICE
    case CPM_DOWNLOAD_CARPARK_INVOICE:
      return {
        ...state,
        downloadOne: {
          ...state.downloadOne,
          downloaded: false,
          downloadRequested: true,
          error: null,
          result: null,
        },
      };
    case `${CPM_DOWNLOAD_CARPARK_INVOICE}_ERROR`:
      return {
        ...state,
        downloadOne: {
          ...state.downloadOne,
          error: action.error,
        },
      };
    case `${CPM_DOWNLOAD_CARPARK_INVOICE}_SUCCESS`:
      mutationResult = action.data.downloadCarparkInvoice;
      return {
        ...state,
        downloadOne: {
          ...state.downloadOne,
          downloaded: true,
          result: mutationResult.uri,
        },
      };
    // CPM_DOWNLOAD_CARPARK_INVOICES
    case CPM_DOWNLOAD_CARPARK_INVOICES:
      return {
        ...state,
        downloadMultiple: {
          ...state.downloadMultiple,
          downloaded: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DOWNLOAD_CARPARK_INVOICES}_ERROR`:
      return {
        ...state,
        downloadMultiple: {
          ...state.downloadMultiple,
          error: action.error,
        },
      };
    case `${CPM_DOWNLOAD_CARPARK_INVOICES}_SUCCESS`:
      mutationResult = action.data.downloadCarparkInvoices;
      return {
        ...state,
        downloadMultiple: {
          ...state.downloadMultiple,
          downloaded: true,
          result: mutationResult.uri,
        },
      };
    // CPM_UPDATE_CARPARK_INVOICE
    case CPM_UPDATE_CARPARK_INVOICE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_INVOICE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_INVOICE}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // CPM_RESET_CARPARK_INVOICE_DOWNLOAD_REQUEST
    case CPM_RESET_CARPARK_INVOICE_DOWNLOAD_REQUEST:
      return {
        ...state,
        downloadOne: {
          ...state.downloadOne,
          downloadRequested: false,
          downloaded: false,
          result: null,
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkInvoice;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkInvoice.js